import * as actionTypes from './settingsActionTypes';

export const setAppsettings = (appsettings) => ({type: actionTypes.APPSETTINGS, appsettings:appsettings});